// removed by extract-text-webpack-plugin
module.exports = {"NormalHeader":"NormalHeader__3BIqT","MobileHeader":"MobileHeader__2cdBp","Title":"Title__3GYsW","Body":"Body__phR7J"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/Title/style.scss
// module id = qZCq
// module chunks = 0